
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/taboola",
      function () {
        return require("private-next-pages/destinations/taboola.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/taboola"])
      });
    }
  